import { ref, watch, type Ref } from 'vue';

/**
 * Reactive zxcvbn-backed password-strength score (0–4). zxcvbn ships a ~400 KB
 * English dictionary, so it's loaded lazily on first access — keeping it out
 * of the main bundle. Until the dynamic import resolves, the score is 0.
 */
let zxcvbnLoader: Promise<(pw: string) => { score: number }> | null = null;

function loadZxcvbn(): Promise<(pw: string) => { score: number }> {
  if (zxcvbnLoader === null) {
    zxcvbnLoader = import('zxcvbn').then((m) => m.default as (pw: string) => { score: number });
  }
  return zxcvbnLoader;
}

export function usePasswordStrength(password: Ref<string>): Ref<number> {
  const score = ref(0);

  watch(
    password,
    async (next) => {
      if (!next || next.length === 0) {
        score.value = 0;
        return;
      }
      const zxcvbn = await loadZxcvbn();
      score.value = zxcvbn(next).score;
    },
    { immediate: true },
  );

  return score;
}
